import { getBootstrapConfig } from 'core/window/windowService';

const getCronosHeader = () => {
    const bootstrapConfig = getBootstrapConfig();
    return {
        'AG-Language-Locale': String(bootstrapConfig.language.cultureCode),
        'AG-Language-Id': String(bootstrapConfig.language.languageId),
        'CR-Currency-Id': String(bootstrapConfig.currency.id),
        'CR-Currency-Code': String(bootstrapConfig.currency.code),
    };
};

export { getCronosHeader };
